// 방패 고블린의 절차 방패: 얕은 돔 + 철 테두리. 문양(붉은 바탕, 흰 고리·십자)은 캔버스로 한 번 그린다.
import * as THREE from 'three/webgpu';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';
import { addSmoothNormals } from './gltf';

const R = 0.28;

function shieldTexture(): THREE.Texture {
  const c = document.createElement('canvas');
  c.width = c.height = 256;
  const g = c.getContext('2d')!;
  g.fillStyle = '#34343c';
  g.fillRect(0, 0, 256, 256);
  const mid = 128;
  // 붉은 바탕(약한 방사 명암으로 손그림 느낌)
  const rg = g.createRadialGradient(mid - 18, mid - 22, 10, mid, mid, 124);
  rg.addColorStop(0, '#d8453a');
  rg.addColorStop(0.75, '#b02a2a');
  rg.addColorStop(1, '#7c1c22');
  g.fillStyle = rg;
  g.beginPath(); g.arc(mid, mid, 118, 0, Math.PI * 2); g.fill();
  // 철 테두리 안쪽 선
  g.strokeStyle = '#8a8a96'; g.lineWidth = 9;
  g.beginPath(); g.arc(mid, mid, 113, 0, Math.PI * 2); g.stroke();
  // 흰 고리와 십자 문양
  g.strokeStyle = '#f0e8d4'; g.lineWidth = 8;
  g.beginPath(); g.arc(mid, mid, 66, 0, Math.PI * 2); g.stroke();
  g.lineWidth = 12; g.lineCap = 'round';
  for (let i = 0; i < 4; i++) {
    const a = (i * Math.PI) / 2 + Math.PI / 4;
    g.beginPath();
    g.moveTo(mid + Math.cos(a) * 30, mid + Math.sin(a) * 30);
    g.lineTo(mid + Math.cos(a) * 100, mid + Math.sin(a) * 100);
    g.stroke();
  }
  // 중앙 철제 장식
  g.fillStyle = '#a4a4b0';
  g.beginPath(); g.arc(mid, mid, 26, 0, Math.PI * 2); g.fill();
  g.fillStyle = '#d6d0bc';
  g.beginPath(); g.arc(mid - 5, mid - 6, 11, 0, Math.PI * 2); g.fill();
  // 리벳
  g.fillStyle = '#c9c4b0';
  for (let i = 0; i < 8; i++) {
    const a = (i * Math.PI) / 4;
    g.beginPath(); g.arc(mid + Math.cos(a) * 113, mid + Math.sin(a) * 113, 5, 0, Math.PI * 2); g.fill();
  }
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace;
  t.anisotropy = 4;
  return t;
}

/** 방패 지오메트리(모델 공간: 고블린 몸 앞쪽). 속성은 position·normal·uv만 둔다. */
export function buildShield(): { geometry: THREE.BufferGeometry; map: THREE.Texture } {
  const dome = new THREE.SphereGeometry(0.33, 28, 8, 0, Math.PI * 2, 0, 1.0);
  dome.rotateX(Math.PI / 2); // 극점이 +Z를 향한다
  dome.scale(1, 1, 0.5);
  {
    const p = dome.getAttribute('position');
    const uv = dome.getAttribute('uv');
    for (let i = 0; i < p.count; i++) uv.setXY(i, p.getX(i) / (2 * R) + 0.5, p.getY(i) / (2 * R) + 0.5);
  }
  const rim = new THREE.TorusGeometry(R, 0.028, 6, 28);
  {
    const uv = rim.getAttribute('uv');
    for (let i = 0; i < uv.count; i++) uv.setXY(i, 0.01, 0.01);
  }
  const g = mergeGeometries([dome, rim], false)!;
  dome.dispose(); rim.dispose();
  g.rotateX(-0.12);
  g.translate(-0.12, 0.55, 0.3);
  addSmoothNormals(g);
  return { geometry: g, map: shieldTexture() };
}
